import { useEffect, useState } from "react";
import { Button, Col, Form, Input, message, Row, Switch } from "antd";
import { getData, postData, putData } from "apiServices/common";
import {
  SAMPLE_TYPE_ADD_ENDPOINT,
  SAMPLE_TYPE_EDIT_GET_ENDPOINT,
  SAMPLE_TYPE_EDIT_PUT_ENDPOINT,
} from "apiServices/API_ENDPOINTS";

const toFormValues = (item) => ({
  id: item?.id,
  name: item?.name,
  description: item?.description ?? "",
  status: String(item?.status) === "1",
});

const SampleTypeForm = ({ isEdit, isView, onCloseModal, refetch, selectedItem }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!(isEdit || isView) || !selectedItem?.id) return;

    const fetchEditData = async () => {
      setLoading(true);
      const response = await getData(`${SAMPLE_TYPE_EDIT_GET_ENDPOINT}/${selectedItem.id}/edit`);
      setLoading(false);
      form.setFieldsValue(toFormValues(response?.data?.code === 200 ? response.data.data : selectedItem));
    };
    fetchEditData();
  }, [selectedItem, isEdit, isView, form]);

  const onFinish = async (formValues) => {
    setLoading(true);
    const bodyData = {
      name: formValues?.name,
      description: formValues?.description ?? "",
      status: formValues?.status ? 1 : 0,
    };

    const response = isEdit
      ? await putData(`${SAMPLE_TYPE_EDIT_PUT_ENDPOINT}/${formValues?.id}`, bodyData)
      : await postData(SAMPLE_TYPE_ADD_ENDPOINT, bodyData);
    setLoading(false);

    if (response?.code === 200 || response?.data?.code === 200) {
      message.success(`Type of Sample ${isEdit ? "updated" : "created"} successfully`);
      refetch();
      form.resetFields();
      onCloseModal();
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} disabled={isView}>
      <Form.Item name="id" hidden />
      <Form.Item name="name" label="Name" rules={[{ required: true, message: "Name is required" }]}>
        <Input size="small" placeholder="Name" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea size="small" rows={3} placeholder="Description" />
      </Form.Item>
      <Form.Item name="status" label="Status" valuePropName="checked" initialValue={true}>
        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
      </Form.Item>
      {isView ? (
        <Button type="primary" onClick={onCloseModal} size="small" block disabled={false}>
          Close
        </Button>
      ) : (
        <Row gutter={6}>
          <Col span={12}>
            <Button type="default" danger style={{ width: "100%" }} onClick={onCloseModal} size="small">
              Discard
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }} loading={loading} size="small">
              Save
            </Button>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default SampleTypeForm;
